import {Component, OnInit}            from '@angular/core';
import {NavParams, PopoverController} from '@ionic/angular';
import {Router}                       from '@angular/router';
import {SessionService}               from '../../services/session.service';
import {DataStore}                    from "aws-amplify";
import {Notification}                 from "../../../models";
import {PermissionType}               from "../../API.service";


@Component({
    selector: 'app-home-pop-over',
    templateUrl: './home-pop-over.component.html',
    styleUrls: ['./home-pop-over.component.scss'],
})
export class HomePopOverComponent implements OnInit {
    profileOptions = true;
    homeOptions = true;
    data: any;
    date: any;
    type: 'string';
    notificationsStream
    notifications: Notification[] = [];

    constructor(
            public popoverCtrl: PopoverController,
            public navParam: NavParams,
            private sessionService: SessionService,
            private router: Router) {
    }

    async ngOnInit() {
        if (this.sessionService.user?.permessions == PermissionType.CLIENT) {
            this.notificationsStream = DataStore.observeQuery(Notification, condition =>
                    condition.userId('eq', this.sessionService.user?.id));
        } else if (this.sessionService.user?.permessions == PermissionType.COMMERCIAL) {
            this.notificationsStream = DataStore.observeQuery(Notification, condition =>
                    condition.userId('eq', this.sessionService.user?.id));
        } else if (this.sessionService.user?.permessions == PermissionType.ADMINISTRATOR) {
            this.notificationsStream = DataStore.observeQuery(Notification, condition =>
                    condition.isAdmin('eq', true), {
                sort: s => s.createdAt("DESCENDING"),
            });
        }
        this.notificationsStream.subscribe(x => this.notifications = x.items);

    }

    signout() {
        this.sessionService.signout();
        this.onDismiss({});
        this.router.navigate(['/login']);
    }

    async openProfilePage() {
        this.onDismiss({});
        const currentUser = this.sessionService.getCurrentUser();
        this.router.navigate(['/profile', currentUser.id]);
    }

    homeAction(action) {
        this.onDismiss(action);
    }

    profileAction(action) {
        this.onDismiss({'action': action, data: this.data});
    }

    submitDate() {
        this.onDismiss({data: this.date});
    }

    async onDismiss(data) {
        try {
            await this.popoverCtrl.dismiss(data);
        } catch (err) {
            
        }
    }

    async gotoNotification(n: Notification) {
        await DataStore.save(Notification.copyOf(n, u => {
            u.isSeen = true;
        }))
        if (n.url)
            await this.router.navigateByUrl(n.url);

        this.onDismiss(null);
        
    }
}
